// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 502) return "static/js/502.b4885f4b4.chunk.js";
	if (chunkId === 777) return "static/js/recorder.b4885f4b4.chunk.js";
	if (chunkId === 12) return "static/js/profiler.b4885f4b4.chunk.js";
	if (chunkId === 48) return "static/js/48.b4885f4b4.chunk.js";
	if (chunkId === 723) return "static/js/723.b4885f4b4.chunk.js";
	if (chunkId === 26) return "static/js/26.b4885f4b4.chunk.js";
	if (chunkId === 315) return "static/js/315.b4885f4b4.chunk.js";
	if (chunkId === 631) return "static/js/631.b4885f4b4.chunk.js";
	if (chunkId === 848) return "static/js/848.b4885f4b4.chunk.js";
	if (chunkId === 492) return "static/js/492.b4885f4b4.chunk.js";
	if (chunkId === 564) return "static/js/564.b4885f4b4.chunk.js";
	if (chunkId === 600) return "static/js/600.b4885f4b4.chunk.js";
	if (chunkId === 326) return "static/js/326.b4885f4b4.chunk.js";
	if (chunkId === 659) return "static/js/659.b4885f4b4.chunk.js";
	if (chunkId === 700) return "static/js/700.b4885f4b4.chunk.js";
	if (chunkId === 449) return "static/js/449.b4885f4b4.chunk.js";
	if (chunkId === 372) return "static/js/372.b4885f4b4.chunk.js";
	if (chunkId === 925) return "static/js/925.b4885f4b4.chunk.js";
	if (chunkId === 429) return "static/js/429.b4885f4b4.chunk.js";
	if (chunkId === 956) return "static/js/956.b4885f4b4.chunk.js";
	if (chunkId === 402) return "static/js/402.b4885f4b4.chunk.js";
	// return url for filenames based on template
	return undefined;
};